// Differentiated, player-safe submit-error copy (§B4, consumes D3 error `code`s). The backend
// attaches a stable machine-readable `code` on 400/409 responses alongside an English
// `message` that must NOT be shown to players - we localize off the code only, and fall back to
// the generic string when no code is present (older/other errors stay byte-identical).
const CODE_KEYS = {
  text_too_long: "topik-view.errors.text-too-long",
  text_blank: "topik-view.errors.text-blank",
  issues_empty: "topik-view.errors.issues-empty",
  seriousness_out_of_range: "topik-view.errors.invalid",
  invalid_card: "topik-view.errors.invalid",
  // 409s auto-resync via the saga's GET; the copy just names the catch-up while it happens.
  wrong_step: "topik-view.errors.resync",
  stale_comparison: "topik-view.errors.resync",
  cannot_step_back: "topik-view.errors.cannot-back",
};

export const errorCode = (error) => (
  error && error.response && error.response.data && error.response.data.code
);

export const submitErrorKey = (error) => {
  const code = errorCode(error);
  if (code && CODE_KEYS[code]) return CODE_KEYS[code];

  const status = error && error.response && error.response.status;
  // No response at all = a network/offline failure; 5xx = server trouble - both distinct from
  // a plain validation rejection.
  if (!status || status >= 500) return "topik-view.errors.network";
  return "topik-view.submit-error";
};
